/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconDeviceIpadHorizontal = createReactComponent(
  "device-ipad-horizontal",
  "IconDeviceIpadHorizontal",
  [
    [
      "path",
      {
        d: "M3 6a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-12z",
        key: "svg-0"
      }
    ],
    ["path", { d: "M9 17h6", key: "svg-1" }]
  ]
);

export { IconDeviceIpadHorizontal as default };
//# sourceMappingURL=IconDeviceIpadHorizontal.js.map
